import { createContext, useContext } from 'react'

const PermisosContext = createContext({
  permisos: null,
  usuario: null,
  loading: true
})

export const PermisosProvider = PermisosContext.Provider

export const usePermisosContext = () => useContext(PermisosContext)
